import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import { HelmetProvider } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import AppHeader from './components/header';
import AppHero from './components/hero';
import AppAbout from './components/about';
import AppServices from './components/services';
import AppContact from './components/contact';
import AppFooter from './components/footer';
import SEO from './components/SEO';
import { useRef, useState } from 'react';

function App() {
  const [contactSubject, setContactSubject] = useState("");
  const contactRef = useRef(null);
  const { t, i18n } = useTranslation();
  
  // Update document direction when language changes
  useEffect(() => {
    document.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <HelmetProvider>
      <div className="App" dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
        <SEO
          title={t('meta.home')}
          description={t('meta.about')}
          name="TensorME"
          type="website"
        />
        <header id='header'>
          <AppHeader
            navigateToContacts={(subject) => {
              if (subject === undefined || subject.length === 0) {
                return;
              }
              setContactSubject(`${t('enquiryOn')} ${subject}`)
              contactRef.current?.scrollIntoView({ behaviour: "smooth" })
            }}
          />
        </header>
        <main>
          <AppHero />
          <AppAbout />
          <AppServices />
          <AppContact contactRef={contactRef} subject={contactSubject} />
        </main>
        <footer id="footer">
          <AppFooter />
        </footer>
      </div>
    </HelmetProvider>
  );
}

export default App;
